var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "c-order-items u-margin-bottom-small" },
    [
      _c("div", { staticClass: "c-order-items__header t-heading-6" }, [
        _vm._v("\n    Items\n  ")
      ]),
      _vm._v(" "),
      _vm._l(_vm.items, function(item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "c-order-items__item l-flex l-flex--justify-start"
          },
          [
            _c("img", {
              staticClass: "c-order-items__item-image",
              attrs: { src: _vm.imageSrc(item), alt: item.title }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "c-order-items__item-details" }, [
              _c(
                "p",
                {
                  staticClass:
                    "c-order-items__item-line t-heading-9 l-flex l-flex--justify-between"
                },
                [
                  _vm._v("\n        " + _vm._s(item.title) + "\n        "),
                  _c("span", { staticClass: "c-order-items__line-qty" }, [
                    _vm._v("Qty: " + _vm._s(item.quantity))
                  ])
                ]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "c-order-items__item-line" }, [
                _vm._v("\n        " + _vm._s(item.price) + "\n      ")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "c-order-items__item-line t-heading-9 t-heading-9--light"
                },
                _vm._l(item.properties, function(prop) {
                  return _c(
                    "span",
                    { key: prop[0] },
                    [
                      _vm.visibleProperty(prop[0])
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm._f("capitalize")(prop[0])) +
                                ": " +
                                _vm._s(prop[1])
                            ),
                            _c("br")
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                }),
                0
              )
            ])
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }